import { MentionProps, Mentions, MentionsRef } from "@/shared/form/mention";
import { ForwardedRef, forwardRef } from "react";
import { usePersonMention } from "../../utils/use-person-mention";

export const PersonMentionInput = forwardRef(function PersonMentionInput(
  props: MentionProps,
  ref: ForwardedRef<MentionsRef>,
) {
  const { value, onChange, ...rest } = props;
  const { toStringWithIds, toStringWithPersonNames, loading, mentionOptions } =
    usePersonMention();

  return (
    <Mentions
      ref={ref}
      loading={loading}
      options={mentionOptions}
      filterOption={(input, option) => {
        return (option as { value: string; label: string }).label
          .toLowerCase()
          .includes(input.toLowerCase());
      }}
      split=""
      autoSize
      value={toStringWithPersonNames(value)}
      onChange={(text) => {
        onChange?.(toStringWithIds(text));
      }}
      {...rest}
    />
  );
});
